/** Accueil unique. Les disponibilités de l'équipe sont dans l'espace Équipe (`features/team`, 18/10/2026). */
import type { AppRoute } from '../../app/route-types.js';
// Éager : le premier écran de chaque compte, pour un premier rendu instantané (§16, Q144).
import { HomePage } from './HomePage.js';
import { COMPANY_SETUP_PATH, CompanySetupPage } from '../onboarding/CompanySetupCard.js';

export const homeRoutes: AppRoute[] = [
  // Un seul accueil pour tous : ses blocs suivent les droits et la vue terrain (17/10/2026).
  { path: '/', element: <HomePage /> },
  // La « Mise en route » : ses étapes restantes, pour qui règle l'entreprise (carte de l'accueil → ici).
  { path: COMPANY_SETUP_PATH, element: <CompanySetupPage />, gate: { anyOf: ['settings.manage'] } },
];
